import React, { Component } from 'react';
import styles from './auth.module.scss';
import classnames from 'classnames';
import SixDigitInput from './sixDigitInput.js';
import API, { VERIFICATION_VIA_SMS } from '../utils/API';
import Error from '../Error/error';
import PrimaryButton from '../Buttons/primaryButton';
import SecondaryButton from '../Buttons/secondaryButton';
import TickIcon from '../../img/icons/tick-icon.svg';
import Loader from '../Loader/index';
import { strings } from '../utils/translations';
import { Errors } from '../utils/errors';

export default class VerifyPhone extends Component
{
    code = null;
    changePhoneViaEmailCode = null;
    
    constructor(props)
    {
        super(props);
        
        this.state =
        {
            generatingSmsCode: false,
            generatingSmsCodeError: false,
            
            sendingSms: false,
            sendingSmsError: false,
            smsSent: false,
            
            sendingCode: false,
            sendingCodeError: false,
            phoneVerified: false,
            
            showDidntReceiveDialog: false,
            showChangePhoneDialog: false,
            newPhone: '',
            newPhoneError: false,
            changingPhone: false,
            showChangePhoneViaEmailCode: false
        }
    }
    componentDidMount()
    {
        this.generateSmsCode();
    }
    
    render()
    {
        const sendingView =
            <>
                <div className={styles.progressBar}>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                </div>
                <h3 className={styles.authTitle}>{ strings('verifyYourPhone') }</h3>
                <Loader />
            </>;
        
        const generatingSmsCodeErrorView =
            <>
                <div className={styles.progressBar}>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                </div>
                <h3 className={styles.authTitle}>{ strings('verifyYourPhone') }</h3>
                <Error text={ strings('errorGeneratingCode') } />
                <PrimaryButton
                    text={ strings('retry') }
                    onClick={() => this.generateSmsCode()}
                />
            </>;
        
        const sendingSmsErrorView =
            <>
                <div className={styles.progressBar}>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                </div>
                <h3 className={styles.authTitle}>{ strings('verifyYourPhone') }</h3>
                <Error text={ strings('errorSendingVerificationSms') } />
                <PrimaryButton
                    text={ strings('retry') }
                    onClick={() => this.sendSms()}
                />
            </>;
            
        const sendingCodeErrorView =
            <>
                <div className={styles.progressBar}>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                </div>
                <h3 className={styles.authTitle}>{ strings('verifyYourPhone') }</h3>
                <Error text={ strings('errorSendingVerificationCode') } />
                <SecondaryButton
                    text={ strings('editCode') }
                    onClick={() => this.setState({ sendingCodeError: false })}
                />
                <PrimaryButton
                    text={ strings('retry') }
                    onClick={() => this.sendVerifyUserByCode(this.code)}
                />
            </>;
        
        const title = <h3 className={styles.authTitle}>{ strings('verifyYourPhone') }</h3>
        const subtitle = <div className={styles.verifyContainer}>
                            <p>{ strings('verifyPhoneText1') + ' ' }
                                <strong>{ ` ${this.getUserPhone()}` }</strong>
                            </p>
                            <br />
                            <p>{ strings('verifyPhoneText2') }</p>
                        </div>
                        
        const didntReceiveDialog =
            <div className={styles.alternativeBox}>
                <h3 className={ classnames([styles.authTitle, styles.secondary]) }>{ strings('didntReceiveCode') }</h3>
                <div className={styles.verifyContainer}>
                    <p>{ strings('weSentTheCodeToThisPhone') }</p>
                    <strong>{ this.getUserPhone() }</strong>
                </div>

                <SecondaryButton
                        text={ strings('resend') }
                        onClick={() =>
                        {
                            this.setState({ showDidntReceiveDialog: false }, () =>
                            {
                                this.sendSms(() =>
                                {
                                    return (
                                        this.setState({ 
                                            error: true,
                                            errorText: strings('codeResent')
                                        })
                                    )
                                });
                            });
                        }}
                />
                <PrimaryButton
                    text={ strings('changePhone') }
                    onClick={() => this.setState({ showChangePhoneDialog: true, showDidntReceiveDialog: false }) }
                />
            </div>;
        
        const changePhoneDialog =
            <div className={styles.alternativeBox}>
                <h3 className={ classnames([styles.authTitle, styles.secondary]) }>{ this.state.showChangePhoneViaEmailCode ? 'Cambiar teléfono' : '¿No has recibido un código?' }</h3>
                <div className={styles.verifyContainer}>
                    {
                        this.state.showChangePhoneViaEmailCode ?
                        <>
                            <p>{ strings('verifyEmailText1') }
                            <strong>{ (this.props.user != null || this.props.email != null) ? ` ${this.getUserEmail()}` : null }</strong></p>
                            <br />
                            <p>{ strings('verifyEmailText2ChangePhone') }</p>
                        </>
                        :
                        <p>{ strings('writeNewPhoneForYourAccount') }</p>
                    }
                    {
                        this.state.changingPhone ?
                        <Loader />
                        :
                        (
                            this.state.showChangePhoneViaEmailCode ?
                            <div className={styles.box}>
                                <SixDigitInput
                                    small
                                    onCodeChanged={this.onChangePhoneCodeChanged.bind(this)}
                                    onCodeFilled={this.onChangePhoneCodeFilled.bind(this)}
                                ></SixDigitInput>
                            </div>
                            :
                            <input
                                type='number'
                                placeholder='+34600123456'
                                className="input"
                                value={this.state.newPhone}
                                onChange={e => this.setState({ newPhone: e.target.value })}
                            />
                        )
                    }
                </div>
                
                <div className={styles.box}>
                    {
                        this.state.newEmailError &&
                        <p>{ strings('phoneHasWrongFormat') }</p>
                    }
                </div>
                
                <SecondaryButton
                    text="Cancelar"
                    onClick={() =>
                    {
                        if (this.state.showChangePhoneViaEmailCode)
                            this.setState({ showChangePhoneViaEmailCode: false });
                        else
                            this.setState({ showChangePhoneDialog: false, showDidntReceiveDialog: true });
                    }}
                />
                {
                    this.state.showChangePhoneViaEmailCode ?
                    <PrimaryButton
                        text={ strings('resend') }
                        onClick={() =>
                        {                            
                            this.changePhoneLogin(() =>
                            {
                                return (
                                    <Error text={ strings('codeResent') } />
                                )
                            });
                        }}
                    />
                    :
                    <PrimaryButton
                        text={ strings('changePhone') }
                        onClick={() =>
                        {
                            if (this.validateNewPhone())
                                this.changePhone();
                        }}
                    />
                }
            </div>;
        
        const codeView =
            <>
                <div className={styles.progressBar}>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                </div>
                    { title }
                    { subtitle }
                
                <div className={styles.box}>
                    <SixDigitInput
                        onCodeChanged={this.onCodeChanged.bind(this)}
                        onCodeFilled={this.onCodeFilled.bind(this)}
                    ></SixDigitInput>
                </div>
                
                <div onClick={() => this.setState({ showDidntReceiveDialog: true })}>
                    <p className={styles.secondaryText}>
                        ¿No has recibido un SMS?
                        <a>HAZ CLICK AQUÍ</a>
                    </p>
                </div>
                
                { 
                    this.state.showDidntReceiveDialog &&
                    didntReceiveDialog
                }
                {
                    this.state.showChangePhoneDialog &&
                    changePhoneDialog
                }
            </>;
            
        const verifiedView =
            <>
                <div className={styles.progressBar}>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                    <span className={ classnames([styles.progress, styles.active]) }></span>
                </div>
                <h3 className={styles.authTitle}>{ strings('phoneVerified') }</h3>
                <div className={styles.verifyContainer}>
                    <div className={styles.verifyText}>
                        <img
                            className={styles.icon}
                            alt="Arrow icon"
                            src={TickIcon}
                        />
                        <p className={styles.primaryText}>{ strings('emailVerifiedSuccess') }</p>
                    </div>
                    <div className={styles.verifyText}>
                        <img
                            className={styles.icon}
                            alt="Arrow icon"
                            src={TickIcon}
                        />
                        <p className={styles.primaryText}>{ strings('phoneVerifiedSuccess1') }</p>
                    </div>
                    <div className={styles.verifyText}>
                        <img
                            className={styles.icon}
                            alt="Arrow icon"
                            src={TickIcon}
                        />
                        <p className={styles.primaryText}>{ strings('accountActive') }</p>
                    </div>
                </div>
            </>;
        
            
        let view = null;
        
        if (this.state.generatingSmsCode)
            view = sendingView;
        else if (this.state.generatingSmsCodeError)
            view = codeView;
        
        if (this.state.sendingSms)
            view = sendingView;
        else if (this.state.sendingSmsError)
            view = sendingSmsErrorView;
        else if (this.state.smsSent)
            view = codeView;
        
        if (this.state.sendingCode)
            view = sendingView;
        else if (this.state.sendingCodeError)
            view = sendingCodeErrorView;
        else if (this.state.phoneVerified)
            view = verifiedView;
        
        return (
            <div>
                { view }
            </div>
        );
    }
    
    onCodeChanged(code)
    {
        this.code = code;
    }
    onCodeFilled()
    {
        this.sendVerifyUserByCode(this.code);
    }
    
    onChangePhoneCodeChanged(code)
    {
        this.changePhoneViaEmailCode = code;
    }
    onChangePhoneCodeFilled()
    {
        this.verifyChangePhoneLogin();
    }
    
    getUserId()
    {    
        return this.props.userId != null ? this.props.userId : this.props.user.id;
    }
    getUserEmail()
    {    
        return this.props.userId != null ? this.props.email : this.props.user.email;
    }
    getUserPhone()
    {
        let phone = null;
        
        if (this.props.user != null)
            phone = this.props.user.phoneNumber;
        else if (this.changePhoneViaEmailCode != null)
            phone = this.state.newPhone;
        else if (this.props.phoneNumber != null)
            phone = this.props.phoneNumber;
            
        return phone;
    }
    
    generateSmsCode()
    {
        this.setState({ generatingSmsCode: true, generatingSmsCodeError: false }, () =>
        {
            API.getInstance().generateVerificationCode(this.getUserEmail())
            .then(response =>
            {
                this.setState({ generatingSmsCode: false }, () =>
                {
                    this.sendSms();
                });
            })
            .catch(error =>
            {
                console.log(error);

                this.setState({
                    generatingSmsCode: false,
                    generatingSmsCodeError: true,
                    error: true,
                    errorText: Errors.showAppError(error)
                });
            });
        });
    }
    sendSms()
    {
        this.setState({ sendingSms: true, sendingSmsError: false, smsSent: false }, () =>
        {
            API.getInstance().sendVerificationCode(this.getUserId(), VERIFICATION_VIA_SMS)
            .then(response =>
            {
                this.setState({ sendingSms: false, smsSent: true });
            })
            .catch(error =>
            {
                console.log(error);

                this.setState({
                    sendingSms: false,
                    sendingSmsError: true,
                    error: true,
                    errorText: Errors.showAppError(error)
                });
            });
        });
    }
    sendVerifyUserByCode(code)
    {
        this.setState({ sendingCode: true, sendingCodeError: false, phoneVerified: false }, () =>
        {
            API.getInstance().verifyUserByCode(this.getUserId(), code, this.getUserPhone())
            .then(response =>
            {
                if (!response.data.status)
                {
                    this.setState({ sendingCode: false, sendingCodeError: true });
                    
                    return (
                        <Error text={ strings('error') } />
                    )
                }
                else
                {
                    this.setState({ sendingCode: false, phoneVerified: true }, () =>
                    {
                        setTimeout(() =>
                        {
                            if (this.props.onPhoneVerified != null)
                                this.props.onPhoneVerified(response.data.status);
                        }, 5000);
                    });
                }
            })
            .catch(error =>
            {
                console.log(error);

                this.setState({
                    sendingCode: false,
                    sendingCodeError: true,
                    error: true,
                    errorText: Errors.showAppError(error)
                });
            });
        });
    }
    
    validateNewPhone()
    {
        let allOk = true;
                
        if (this.state.newPhone.trim().length == 0 || this.state.newPhone.trim().charAt(0) != '+')
        {
            allOk = false;
        }
        
        if (!allOk)
        {
            return (
                <Error text={ strings('phoneHasWrongFormat') } />
            )
        }
        
        this.setState({ newPhoneError: !allOk });
        
        return allOk;
    }
    changePhone()
    {
        if (this.props.userId != null)
            this.changePhoneLogin();
        else
            this.changePhoneSignup();
    }
    changePhoneSignup()
    {
        this.setState({ changingPhone: true }, () =>
        {
            API.getInstance().createAccount(this.props.user.name, this.props.user.lastName, this.state.newPhone, this.props.user.email, this.props.user.password)
            .then(response =>
            {
                if (this.props.onUserUpdated != null)
                    this.props.onUserUpdated(response.data);
                
                this.setState(
                {
                    changingPhone: false,
                    showDidntReceiveDialog: false,
                    showChangePhoneDialog: false
                },
                () =>
                {
                    this.sendSms();
                    this.setState({ newPhone: '' });
                });
            })
            .catch(error =>
            {
                console.log(error);

                this.setState({
                    changingPhone: false,
                    error: true,
                    errorText: Errors.showAppError(error)
                });
            });
        });
    }
    changePhoneLogin(callback)
    {
        this.setState({ changingPhone: true }, () =>
        {
            API.getInstance().changePhoneViaEmail(this.state.newPhone, this.getUserEmail())
            .then(response =>
            {
                this.setState(
                {
                    changingPhone: false,
                    showChangePhoneViaEmailCode: true
                }, () =>
                {
                    if (callback != null)
                        callback();
                });
            })
            .catch(error =>
            {
                console.log(error);

                this.setState({
                    changingPhone: false,
                    error: true,
                    errorText: Errors.showAppError(error)
                });
            });
        });
    }
    verifyChangePhoneLogin()
    {
        this.setState({ changingPhone: true }, () =>
        {
            API.getInstance().verifyChangePhoneViaEmail(this.state.newPhone, this.getUserEmail(), this.changePhoneViaEmailCode)
            .then(response =>
            {
                if (!response.data.status)
                {
                    this.setState({ changingPhone: false });

                    return (
                        <Error text={ strings('error') } />
                    )
                }
                else
                {
                    this.setState(
                    {
                        changingPhone: false,
                        showChangePhoneViaEmailCode: false,
                        showDidntReceiveDialog: false,
                        showChangePhoneDialog: false,
                        error: true,
                        errorText: strings('phoneChanged')
                    },
                    () =>
                    {
                        this.generateSmsCode();
                    });
                }
            })
            .catch(error =>
            {
                console.log(error);

                this.setState({
                    changingPhone: false,
                    error: true,
                    errorText: Errors.showAppError(error)
                });
            });
        });
    }
}